import { ProcurementProvider } from './procurementContext';
import { ProcurementFilterBar } from './components/ProcurementFilterBar';
import { ProcurementBoard } from './components/ProcurementBoard';

/**
 * Punto de entrada del slice: provee su contexto de filtros (aislado del de
 * ventas), pinta la barra de filtros a lo ancho (mismo patrón que ventas) y
 * el tablero. Montar con `<ProcurementPage />` directo bajo el header.
 */
export function ProcurementPage() {
  return (
    <ProcurementProvider>
      <ProcurementFilterBar />
      <main className="p-4">
        <ProcurementBoard />
      </main>
    </ProcurementProvider>
  );
}
